"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
const react_peg_1 = require("react-peg");
const parser_1 = require("../parser");
const generator_1 = require("../generator");
const generator_2 = require("@babel/generator");
const Tracer = require("pegjs-backtrace");
function transform(source, config = { debug: false }) {
    const tracer = new Tracer(source, { useColor: false });
    const options = { tracer: config.debug ? tracer : null };
    const parser = react_peg_1.ReactPeg.render(react_peg_1.ReactPeg.createChunk(parser_1.TypeFile, null), options);
    try {
        const ast = parser.parse(source);
        const tsFile = generator_1.TSFile(ast);
        const code = generator_2.default(tsFile).code;
        const result = {
            code,
        };
        return result;
    }
    catch (error) {
        error['backtrace'] = tracer.getBacktraceString();
        throw error;
    }
}
exports.transform = transform;
